import React, { Component } from 'react';
import s from './style.module.scss';

import SectionComponent from '../../_sectionComponent';
import Modal from '../../../Modals/RearModal/';

class BootCoupe extends Component {
  render() {
    return (
      <path
        className={s.boot}
        {...this.props}
        d="M938.6,606.9c-0.2,0.5,39.1-4.6,49.1-6.4c1.1-0.2,1.9-68.4,1.9-70.5V408c0-4.4-0.5-87.6-2.9-88l-48.1-6.5  C958.6,367,957.1,545.7,938.6,606.9z"
      />
    );
  }
}

let composed = BootCoupe;
composed = SectionComponent({
  name: 'Boot',
  category: 'Panels',
  highlighted: false,
  questionSets: ['Rear'],
  modalModel: {
    title: 'Register Boot Damage',
    content: <Modal name="Boot" />,
  },
})(composed);

export default composed;
